import React from 'react';
import styled from 'styled-components';

const FullScreen = styled.div`
    position: absolute;
    display: flex;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
`;

const AnimationModal = ({children}) => {
    return <FullScreen>{children}</FullScreen>
}

export default AnimationModal;